/* eslint-disable */
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  RACButton,
  RACSelect,
  RACTextbox,
  RACDatePicker,
  RACRadio,
  List,
  ListItem,
  CircularProgress,
  RACModalCard,
  RACTooltip,
  TextField,
  RACMUIDatePicker,
} from "@rentacenter/racstrap";
import { addDays } from "date-fns";
import moment from "moment";
import clsx from "clsx";
import {
  getTimeSlot,
  getConfigDetails,
  postAppointment,
  manageAppointment,
  getRadiusStores,
  getCustomerAppointment,
  getCustomerActiveAddress,
  getAgreementDelivery,
  getAgreementInfo,
  updateEventStatus,
  scheduleDelivery,
} from "../../api/user";
import { ReactComponent as AlertIcon } from "../../assets/images/no-records-found.svg";
import { ReactComponent as Successimage } from "../../assets/images/success-icon.svg";
import { agreementGlobalStyles } from "./DAPStyles";
import Modal from "react-modal";
import { daysUntilSunday } from "../../utils/utils";
import {
  EVENT_TYPES,
  getEventType,
  ScheduleFieldVisitDTO,
} from "../../types/types";
import { debuggerStatement } from "@babel/types";
import { FIELD_VISIT_NOTES_MAX_LENGTH } from "./FieldVisitModal";
import { EventStatusActionType } from "../../domain/Calendar/CalendarEvent";
import { StoreStateContext } from "../../context/store/StoreProvider";
const MAX_LOAD_DAYS: number = 8;
// let prevEl: any, currEl: any = ''
export default function FieldVisitEvent() {
  const { t } = useTranslation("task");

  const history = useHistory();
  let historyData: any = history.location.state;
  
  // let bindtimeslotDate = '';

  const classes = agreementGlobalStyles();
  const [data, setData] = useState<any>({
    EventTitle: "",
    Time: "",
    Description: "",
  });
  const [dropDown, setDropDown] = useState<any>({
    scheduleArray: "1",
    coWorkerArray: "1",
  });
  const [Color, setColor] = useState(`${classes.blue}`);
  const { dateTimeLocalization } = useContext(StoreStateContext);
  const [timeSlotData, settimeSlotData]: any = useState([]);
  const [bindtimeslotId, setBindtimeslotId] = useState("");
  const [maxNumofTimeSlots, setMaxNumofTimeSlots] = useState("4");
  const [bindtimeslotDate, setBindtimeslotDate] = useState("");
  const [ContextStartDate, SetContextStartDate] = useState("");
  const [ContextEndDate, SetContextEndDate] = useState("");
  const [choosenTime, setChoosenTime] = useState("");
  const [masterLoader, setmasterLoader] = React.useState(false);
  const [timeslotid, setTimeslotid] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [targetDate, setTargetDate] = useState(moment().format("YYYY-MM-DD"));

  const [appoinmentSource, setAppoinmentSource]: any = React.useState("");
  const [apierror, setApierror] = React.useState(false);
  const [ApierrorContent, setApierrorContent] = React.useState("");
  const [errorMsg, setErrorMsg] = useState<boolean>(false);
  const [multiMode, setMultiMode] = useState<boolean>(false);
  const [coWorkerRequiredArray, setcoWorkerRequiredArray]: any = useState([]);
  const [conditionLoader, SetconditionLoader] = useState(true);
  const [coworkers, setCoworkers]: any = useState("");
  const storeNumber = window.sessionStorage.getItem("storeNumber");
  const [loader, setloader] = useState(false);
  const [headerPresent, setHeaderPresent] = useState(false);
  const [FVSConfigurable, setFVSConfigurable] = useState<boolean>(false);
  const [enablePFVPhase2, setEnablePFVPhase2] = useState<boolean>(false);
  const [tsloader, setTsloader] = useState(false);
  const [paramValue, setParamValue] = useState<any>("");
  const [currentBtnClass, setCurrentBtnClass] = useState<any>("");
  const [FVSdata, setFVSdata] = useState<any[]>([]);

  const [OpendeliveryOverridepopup, SetOpendeliveryOverridepopup] =
    useState(false);
  const [OpenDeliveryFailedPopup, SetOpenDeliveryFailedPopup] = useState(false);
  const [isFVOverride, SetisFVOverride] = useState(false);
  

  const [maxDate, setMaxDate] = useState<any>("2099-12-31");
  const [bestFit, setBestFit] = useState("N");

  const source = useRef<any>();

  const setSource = (src) => {
    source.current = src;
  };

  const handleInputChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    pageLoad();
  }, []);

  useEffect(() => {
    const { isRenderedByContainer } = window;
    setHeaderPresent(
      isRenderedByContainer != null && isRenderedByContainer != undefined
        ? true
        : false
    );
  }, []);

  const pageLoad = async () => {
    setloader(true);
    if (historyData?.source) {
      setSource(historyData.source);
    }
    let { priorityPhase2, priorityPhase3 } = await getConfigData();

    const queryParams = new URLSearchParams(window.location.search);

    const queryparamValue = queryParams.get("editevent");
    setParamValue(queryparamValue);
    let targetDate: any = "";
    let endDate: any = "";
    if (
      (Array.isArray(queryparamValue) && queryparamValue.length > 0) ||
      (!Array.isArray(queryparamValue) && queryparamValue)
    ) {
      setData({
        EventTitle: historyData?.appointmentInfo?.title || "",
        Time: "",
        Description: historyData?.appointmentInfo?.instructions || "",
        customerId: historyData?.customerInfo?.customerId || "",
        firstName: historyData?.customerInfo?.firstName || "",
        lastName: historyData?.customerInfo?.lastName || "",
        completeProcessingName:
          historyData?.customerInfo?.firstName ||
          "" + " " + historyData?.customerInfo?.lastName ||
          "",
        address1: historyData?.customerInfo?.address?.addressLine1 || "",
        address2: historyData?.customerInfo?.address?.addressLine2 || "",
        city: historyData?.customerInfo?.address?.city || "",
        state: historyData?.customerInfo?.address?.state || "",
        postalCode: historyData?.customerInfo?.address?.postalCode || "",
        appointmentId: historyData.appointmentInfo.appointmentId,
        agreementNumber: historyData?.agreement,
        inventoryNumber: historyData?.inventories[0]?.inventoryNumber,
      });
      setEditView(historyData.timeSlotInfo, historyData.appointmentInfo);
    } else {
      // new functionality
      setloader(true);
      if (priorityPhase3) {
        // new data struction allows array of IDs to be transmitted   only works for priority visit.  MUST pass in an ARRAY!!!!
        // note:  even when passing in 1 customer it must be an ARRAY of 1
        // NOTE:  when in DAP screen and doing an edit the EDITEvent Query parmeter is ALWAYS set (and must continue to be )
        if (historyData?.source == "priorityvisit") {
          const items = mapFVSData();
          await processFVSCustomer(items);
          setMultiMode(true);
        } else if (historyData?.source == "pastdue") {
          const items = mapFVSData();
          await processFVSCustomer(items);
          setMultiMode(true);
        } else if (historyData?.source == "customer") {
          const items = mapFVSData();
          await processFVSCustomer(items);
          setMultiMode(true);
        } else if (historyData?.source == "agreement") {
          // Fetch the FV events for specific timeslot
          await processFVEvents();
          setMultiMode(false);
        }
      } else {
        setCreateView();
      }
    }
    doload(priorityPhase2, targetDate);
  };

  const findAgmId = (address: any, agreementNumber: any) => {
    const alladdresses = address?.GetCustomerAddress?.value?.addresses;

    let agmId = null;
    for (const adr of alladdresses) {
      if (!agmId) agmId = adr.agreementId;
      if (adr.agreementNumber == agreementNumber) {
        agmId = adr.agreementId;
        break;
      }
    }

    return agmId;
  };

  const determineInventory = async (agmId: any) => {
    const agreementInfo = await getAgreementInfo(agmId);

    return agreementInfo?.data?.agreementInventories?.[0]?.inventoryNumber;
  };

  const setCreateView = () => {
    setParamValue(false);
    setData({
      Time: "",
      customerId: historyData?.customerInfo?.customerId || "",
      firstName: historyData?.customerInfo?.firstName || "",
      lastName: historyData?.customerInfo?.lastName || "",
      completeProcessingName:
        historyData?.customerInfo?.firstName ||
        "" + " " + historyData?.customerInfo?.lastName ||
        "",
      address1: historyData?.customerInfo?.address?.addressLine1 || "",
      address2: historyData?.customerInfo?.address?.addressLine2 || "",
      city: historyData?.customerInfo?.address?.city || "",
      state: historyData?.customerInfo?.address?.state || "",
      postalCode: historyData?.customerInfo?.address?.postalCode || "",
      agreementNumber: historyData?.agreement,
      inventoryNumber: historyData?.inventories?.[0]?.inventoryNumber,
    });

    if (enablePFVPhase2) {
      const nextdate = moment();
      const maxdateToSet = nextdate
        .add(daysUntilSunday(), "days")
        .format("YYYY-MM-DD");
      setMaxDate(maxdateToSet);
    } else {
      setMaxDate(moment().format("YYYY-MM-DD"));
    }
  };

  const setEditView = (timeSlotInfo, appointmentInfo) => {
    const startTime = moment(timeSlotInfo.startTime, "HH:mm:ss").format(
      "hh:mm A"
    );
    const endTime = moment(timeSlotInfo.endTime, "HH:mm:ss").format("hh:mm A");

    setParamValue(true);
    setChoosenTime(startTime + "-" + endTime);
    setTimeslotid(timeSlotInfo.timeSlot);
    setCoworkers(appointmentInfo.requiredCoworkers || "1");
    const targetDate = moment(timeSlotInfo.startTimeStamp).format("YYYY-MM-DD");

    if (enablePFVPhase2) {
      const endingdate = moment(targetDate)
        .add(daysUntilSunday(), "days")
        .format("YYYY-MM-DD");
      setMaxDate(endingdate);
    } else {
      setMaxDate(targetDate);
    }

    setStartDate(moment(timeSlotInfo.startTimeStamp).format("YYYY-MM-DD"));
    if (appointmentInfo?.bestFit == "1") {
      setBestFit("Y");
      setChoosenTime("");
    }
  };

  const buildNames = (items: any): string => {
    const name = items.map((one) => one.name).join(",");
    return name;
  };
  const formatFullName = (fname: string, lname: string): string => {
    return `${fname} ${lname}`;
  };
  const jumpBackToOrigin = () => {
    if (source?.current == "priorityvisit") {
      history.push({ pathname: `/am/priorityvisit` });
    } else if (source?.current == "customer") {
      history.push({ pathname: `/am/customer/${data.customerId}` });
    } else if (source?.current == "agreement") {
      history.push({ pathname: historyData?.sourceUrl });
    } else {
      history.push({ pathname: `/am/past-due-list` });
    }
  };

  const shiftEntry = (): any => {
    const allNames = data.completeProcessingName;
    if (FVSdata.length > 1) {
      // there are more to process
      const newlist = FVSdata.slice(1); // remove first entry
      setFVSdata(newlist);

      const names = allNames.split(",");
      names.shift(); // removes the first item
      const newListOfNames = names.join(",");
      setData({ ...data, completeProcessingName: newListOfNames });

      const newState = Object.fromEntries(
        newlist.map((one, idx) => [idx, one])
      );

      history.push(`${history.location.pathname}`, {
        ...newState,
        source: source.current,
      });

      return newlist;
    }

    return;
  };
  const processFVEvents = async () => {
    if (historyData.source === "agreement") {
      SetisFVOverride(historyData?.isFVOveride);
      const apptDate = historyData.agreementDetails.eventInformation.loanerCreate.appointmentInfo.appointmentDate;
      const timeSlot =  historyData.agreementDetails.eventInformation.loanerCreate.timeSlot;
      // Use the timeslot date to fetch all the FV events
      const payload = {
        storeNumber: storeNumber,
        startDate: apptDate,
        endDate: apptDate,
        appointmentTypes: ["FIELD"],
      };
      const apts = await getCustomerAppointment(payload);

      if (apts?.appointments && apts?.appointments.length > 0) {
        // Filter the FV events matching required timeslot
        const appointments = apts?.appointments?.filter(
          (items: any) => items.timeSlotInfo.timeSlot === timeSlot
        );
        if (appointments?.[0]?.appointmentInfo?.appointmentType) {
          const appointmentInfo = appointments[0].appointmentInfo;
          const customerInfo = appointments[0].customerInfo;
          const timeslotInfo = appointments[0].timeSlotInfo;
          const inventoryInfo = appointments[0].inventories[0];
          const agreementInfo = appointments[0]?.agreement;
          const completeName = formatFullName(
            customerInfo?.firstName,
            customerInfo?.lastName
          );

          // edit mode so map the data
          setData({
            EventTitle: appointmentInfo?.title || "",
            Time: "",
            Description: appointmentInfo?.instructions || "",
            customerId: customerInfo?.customerId || "",
            firstName: customerInfo?.firstName || "",
            lastName: customerInfo?.lastName || "",
            completeProcessingName: completeName,
            address1: customerInfo?.address?.addressLine1 || "",
            address2: customerInfo?.address?.addressLine2 || "",
            city: customerInfo?.address?.city || "",
            state: customerInfo?.address?.state || "",
            postalCode: customerInfo?.address?.postalCode || "",
            appointmentId: appointmentInfo?.appointmentId,
            agreementNumber: agreementInfo?.agreementNumber,
            inventoryNumber: inventoryInfo?.inventoryNumber,
          });
          setEditView(timeslotInfo, appointmentInfo);
          setParamValue(false);
        }
      }  // todo:  what if there are no FIELD  appointments for that date ? 
    }
  };

  const processFVSCustomer = async (items: any) => {
    if (items.length > 0) {
      const completeNames = buildNames(items);
      // process the first one in the list
      const oneCustomer = items[0] as ScheduleFieldVisitDTO; // only remove it when the user saves or cancels

      const payload = {
        storeNumber: storeNumber,
        customerInfo: {
          customerId: oneCustomer.customerId,
        },
        appointmentTypes: ["FIELD"],
      };
      // search the customer & store to see if they ALREADY have an appointment
      const apt = await getCustomerAppointment(payload);

      if (apt?.appointments?.[0]?.appointmentInfo?.appointmentType) {
        const appointmentInfo = apt.appointments[0].appointmentInfo;
        const customerInfo = apt.appointments[0].customerInfo;
        const timeslotInfo = apt.appointments[0].timeSlotInfo;
        const inventoryInfo = apt.appointments[0].inventories[0];

        // edit mode so map the data
        setData({
          EventTitle: appointmentInfo?.title || "",
          Time: "",
          Description: appointmentInfo?.instructions || "",
          customerId: customerInfo?.customerId || "",
          firstName: customerInfo?.firstName || "",
          lastName: customerInfo?.lastName || "",
          completeProcessingName: completeNames,
          address1: customerInfo?.address?.addressLine1 || "",
          address2: customerInfo?.address?.addressLine2 || "",
          city: customerInfo?.address?.city || "",
          state: customerInfo?.address?.state || "",
          postalCode: customerInfo?.address?.postalCode || "",
          appointmentId: appointmentInfo?.appointmentId,
          agreementNumber: oneCustomer?.agreementNumber,
          inventoryNumber: inventoryInfo?.inventoryNumber,
        });
        setEditView(timeslotInfo, appointmentInfo);
      } else {
        // create mode

        const addr = await getCustomerActiveAddress(oneCustomer.customerId);
        setCreateView();
        const inventoryNumber = await determineInventory(
          findAgmId(addr, oneCustomer?.agreementNumber)
        );

        setData({
          ...data,
          customerId: addr.GetCustomerAddress.value.customerId || "",
          firstName: addr.GetCustomerAddress.value.firstName || "",
          lastName: addr.GetCustomerAddress.value.lastName || "",
          completeProcessingName: completeNames,
          address1:
            addr.GetCustomerAddress.value.addresses[0].addressLine1 || "",
          address2:
            addr.GetCustomerAddress.value.addresses[0].addressLine2 || "",
          city: addr.GetCustomerAddress.value.addresses[0].city || "",
          state: addr.GetCustomerAddress.value.addresses[0].state || "",
          postalCode:
            addr.GetCustomerAddress.value.addresses[0].postalCode || "",
          agreementNumber: oneCustomer?.agreementNumber,
          inventoryNumber: inventoryNumber,
        });
      }
    }
  };

  const mapFVSData = () => {
    if (historyData) {
      const items = Object.keys(historyData)
        .filter((key) => !isNaN(Number(key)))
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => historyData[key]);
      setFVSdata(items);
      return items;
    }
  };

  const doload = async (priorityPhase2, targetDate) => {
    setloader(true);
    try {
      setBindtimeslotDate(moment().format("YYYY-MM-DD"));

      // await getCoworkerRequiredData();
      if (priorityPhase2 == "1") {
        let finalEndDate = targetDate;
        if (targetDate) {
          finalEndDate = moment(targetDate)
            .add(daysUntilSunday(), "days")
            .format("YYYY-MM-DD");
        } else {
          finalEndDate = moment()
            .add(daysUntilSunday(), "days")
            .format("YYYY-MM-DD");
        }
        await getTimeSlots(moment().format("YYYY-MM-DD"), finalEndDate);
      } else {
        await getTimeSlots(moment().format("YYYY-MM-DD"), targetDate);
      }

      setloader(false);
    } catch (error: any) {
      console.log(error);
      setloader(false);
      setApierrorContent(error);
      setApierror(true);
    }
  };

  const buildUpdatePayload = () => {
    let payload = {
      appointmentId: data.appointmentId,
      storeNumber: storeNumber,
      timeSlot: timeslotid,
      appointmentInfo: {
        appointmentDate: targetDate,
        instructions: data.Description,
        requiredCoworkers: coworkers,
      },
    };
    if (bestFit == "Y") {
      payload.appointmentInfo["bestFit"] = "1";
      if (!timeslotid) {
        payload.timeSlot = getSlot();
      }
    } else {
      payload.appointmentInfo["bestFit"] = "0";
    }
    return payload;
  };
  const buildAppointmentActionPayload = (eventType: any) => {
    const payloadForAppointmentAction: any = {
      storeNumber: storeNumber,
      appointmentId: data.appointmentId,
      actionName: eventType,
    };
    return payloadForAppointmentAction;
  };

  const buildCreatePayload = () => {
    let payload = {
      storeNumber: storeNumber,
      eventInformation: {
        isLoaner: "Y",
        loanerCreate: {
          storeNumber: storeNumber,
          timeSlot: timeslotid,
          customerId: String(data.customerId),
          agreementNumber: data.agreementNumber,
          inventories: [
            {
              inventoryNumber: data.inventoryNumber,
            },
          ],
          appointmentInfo: {
            appointmentType: "FIELD",
            appointmentSource: "STO",
            appointmentDate: targetDate,
            instructions: data.Description,
            requiredCoworkers: coworkers,
          },
        },
      },
    };

    if (bestFit == "Y") {
      payload.eventInformation.loanerCreate.appointmentInfo["bestFit"] = "1";
      payload.eventInformation.loanerCreate.timeSlot = getSlot();
    }
    return payload;
  };

  const handleSave = async () => {
    try {
      setloader(true);

      let eventResponse: any = {};
      if (paramValue) {
        let payload = buildUpdatePayload();
        console.info("update payload", payload);
        eventResponse = await manageAppointment(payload);
      } else {
        let payload: any = buildCreatePayload();
        console.info("create payload", payload);
        eventResponse = await postAppointment(payload);
      }

      setloader(false);
      if (eventResponse?.status == 200) {
        if (multiMode) {
          const items = shiftEntry();
          if (items) {
            setloader(true);
            doload("1", targetDate);
            await processFVSCustomer(items);
            setloader(false);
          } else {
            jumpBackToOrigin();
          }   
            
        } else {
            // not multimode but are you a single delivery ? 
            if (isFVOverride) {
            // Schedule delivery
            const response: any = await scheduleDelivery(historyData?.agreementDetails);

            if (response?.status === 200) {
              // both succeeded !!
              SetOpendeliveryOverridepopup(true);
              
            } else {
              // Field Visit succeeded but the delivery failed
              SetOpenDeliveryFailedPopup(true);
              
            }         
          } else {
            handleCancel();
          }

        }
        
      } else if (eventResponse?.status == 400) {
        if (isFVOverride) {
          setApierror(true);
          setApierrorContent(
            "Field Visit Update Failed. Please schedule events individually"
          );
          handleCancel();
        } else {
          setApierror(true);
          setApierrorContent("Something went wrong");
        }
      } else {
        setErrorMsg(true);
      }
    } catch (e: any) {
      setApierrorContent("Something went wrong");
      setloader(false);
      setApierror(true);
    }
  };

  const jumpToDashboard = async () => {
    history.push({ pathname: "/dashboard/homepage" });
  };

  const apiErrorPopup = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <AlertIcon></AlertIcon>
          <Typography className={`${classes.popupText} ${classes.mt3}`}>
            {t(ApierrorContent)}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setApierror(false);
              history.push(`/storemgmt/dap`);
            }}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const noRecordPopup = () => {
    return (
      <Grid>
        <Grid>
          <Grid className={classes.textCenter}>
            <AlertIcon />
            <Typography> {t("No available timeslots")}</Typography>
          </Grid>
          <Grid
            item
            md={12}
            className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
          >
            <RACButton
              className={classes.mx1}
              variant="contained"
              color="primary"
              onClick={() => setErrorMsg(false)}
            >
              {t("Ok")}
            </RACButton>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const DeliveryOverrideSuccessPopup = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            { t("Field Visit Updated Successfully.")}
          </Typography>
          {isFVOverride && (
            <Typography className={(classes.mt3, classes.pt4, classes.font13)}>
              {t("Delivery Scheduled Successfully.")}
            </Typography>
          )}
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {jumpToDashboard()}}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const DeliveryOverrideFailurePopup = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            { t("Field Visit Updated Successfully.")}
          </Typography>
          <AlertIcon className={classes.mt3}></AlertIcon>
          <Typography className={(classes.mt3, classes.pt4)}>
            {t("Delivery Scheduling Failed.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {handleCancel()}}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const DeliveryOverrideFVFailurePopup = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            { t("Field Visit update Failed!  Please schedule events individually.") }
          </Typography>
          <AlertIcon className={classes.mt3}></AlertIcon>
          <Typography className={(classes.mt3, classes.pt4)}>
            {t("Delivery Scheduleding Failed.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {}}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const getConfigData = async () => {
    try {
      const bodyobject = {
        storeNumbers: [storeNumber],

        paramKeyNames: [
          "CoworkerRequired",
          "PriorityFieldVisitPhase2",
          "EnableFieldVisitStrategy",
        ],
      };
      const configDetails = await getConfigDetails(bodyobject);

      let coworkerNum =
        configDetails?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
          (el: any) => el.paramKeyName == "CoworkerRequired"
        )[0].paramValue;
      if (!coworkerNum) coworkerNum = "0";

      let enablePFVPhase2 =
        configDetails?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
          (el: any) => el.paramKeyName == "PriorityFieldVisitPhase2"
        )[0].paramValue;
      if (!enablePFVPhase2) enablePFVPhase2 = "0";

      let enableFVS =
        configDetails?.storeProfileResponse?.configDetails[0]?.configDetails?.filter(
          (el: any) => el.paramKeyName == "EnableFieldVisitStrategy"
        )[0].paramValue;
      if (!enableFVS) {
        setFVSConfigurable(false);
      }

      if (enableFVS == "1") {
        setFVSConfigurable(true);
      } else {
        setFVSConfigurable(false);
      }

      const integervalue = parseInt(coworkerNum);
      const arrayNumber: any = [{ label: t("Select"), value: "SELECT" }];

      for (let i = 0; i <= integervalue; i++) {
        arrayNumber.push({ label: String(i), value: String(i) });
      }
      // eslint-disable-next-line no-console
      console.log("ArrayNumber", arrayNumber);
      setcoWorkerRequiredArray(arrayNumber);
      SetconditionLoader(false);
      setEnablePFVPhase2(enablePFVPhase2 ? true : false);
      return {
        priorityPhase2: enablePFVPhase2,
        priorityPhase3: enableFVS == "1" ? true : false,
      };
    } catch (error: any) {
      console.log(error);
      setloader(false);
      setApierrorContent(error);
      setApierror(true);
      return { priorityPhase2: "0", priorityPhase3: "0" };
    }
  };

  const getEventDate = async (agrId: any, appointmentId: any) => {
    if (!agrId || !appointmentId) {
      throw "getEventDate. Null Id";
    }
    const response = await getAgreementDelivery(agrId, appointmentId);
    if (response.status !== 200) throw "api error in getEvent";

    if (!response.data.timeSlotInfo) throw "api error in getEvent. No timeslot";

    const result: any = {
      deliverydate: response.data.timeSlotInfo.startTimeStamp.substring(0, 10),
      deliverytime: response.data.timeSlotInfo.startTime,
    };
    return result;
  };

  const Timebind = (event: any) => {
    setChoosenTime(moment(event.target.value).format("hh:mm A"));
    // SetSaveTrigger(false);
  };

  const handleSelectBestFitChange = (e: any) => {
    if (isSlotsBusy()) {
      setErrorMsg(true);
      return;
    }

    setCurrentBtnClass("");
    setBestFit(e.target.value);
  };

  const isSlotsBusy = () => {
    if (timeSlotData.length == 0 || timeSlotData[0].TimeSlots.length == 0) {
      return true;
    }
    const result = timeSlotData[0].TimeSlots.find(
      (item) => item.status === "Available"
    );
    return result ? false : true;
  };
  const getSlot = () => {
    if (timeSlotData.length == 0 || timeSlotData[0].TimeSlots.length == 0) {
      return undefined;
    }
    const result = timeSlotData[0].TimeSlots.find(
      (item) => item.status === "Available"
    );
    if (result) {
      return result.timeSlot;
    }
    return undefined;
  };

  const generateHelpText = (value: any): string | undefined => {
    let out = "";
    console.log("value: ", value);
    for (const oneEventRefCode of Object.keys(EVENT_TYPES)) {
      if (value[oneEventRefCode]) {
        out =
          out +
          value[oneEventRefCode] +
          " " +
          getEventType(oneEventRefCode) +
          "\n";
      }
    }

    if (out) return out;

    return undefined;
  };

  const chooseDates = async (selectedFormatdate: any) => {
    try {
      settimeSlotData([]);
      setTsloader(true);

      setStartDate(moment(selectedFormatdate).format("YYYY-MM-DD"));
      const startDate = selectedFormatdate;
      const endingdate = moment(startDate)
        .add(daysUntilSunday(), "days")
        .format("YYYY-MM-DD");
      setTargetDate(endingdate);
      await getTimeSlots(startDate, endingdate);
      setChoosenTime("");
      setTimeslotid("");
      setTsloader(false);
      console.log("beoefevcdvbh", bindtimeslotId);
      setBindtimeslotId("");
    } catch (error) {
      setTsloader(false);
    }
  };
  function* numCount() {
    let count = 99;
    while (true) yield count++; /*  ww w  .  j av a2s.co  m*/
  }
  const irt = numCount();

  const getTimeSlots = async (startingDate: any, targetDate: any) => {
    if (!targetDate) {
      targetDate = moment().format("YYYY-MM-DD");
    }

    //check start and end
    if (moment(startingDate) > moment(targetDate)) {
      return;
    }

    // const differenceInDays = endddate.diff(startDate, 'days');
    // if (differenceInDays > MAX_LOAD_DAYS) {
    //   targetDate = startDate.add(MAX_LOAD_DAYS, 'days').format('YYYY-MM-DD');
    // }

    const payload = {
      isLoaner: "Y",
      customerId: "108348922",
      endDate: targetDate,
      eventSource: "STO",
      startDate: startingDate,
      storeId: sessionStorage.getItem("storeNumber"),
    };
    const timeslotresponse = await getTimeSlot(payload);
    if (timeslotresponse.status != 200) {
      throw "API Error";
    }
    if (timeslotresponse.data !== undefined) {
      console.log("timeslotresponse", timeslotresponse);

      setAppoinmentSource(timeslotresponse.data.appointmentSource);
      // SetTimeslotReason(timeslotresponse);
      const TimeSlotsDetailsArrayValue: any = [];
      interface TimeSlotDetails {
        timeSlot: string;
        startTime: string;
        endTime: string;
        status: string;
        total?: number;
        helpText?: string;
      }

      interface TimeSlotDetailsArray {
        Date: string;
        TimeSlots: TimeSlotDetails;
      }

      const TimeSlotVariable = timeslotresponse.data.timeSlots;
      const sorted: any = Object.keys(TimeSlotVariable)
        .sort(function (a: any, b: any) {
          const date1: any = new Date(a);
          const date2: any = new Date(b);
          return date1 - date2;
        })
        .reduce((accumulator: any, key: any) => {
          accumulator[key] = TimeSlotVariable[key];

          return accumulator;
        }, {});
      Object.keys(sorted).forEach(function (key) {
        const value = sorted[key];
        //  console.log(key + ':' + value);
        const Timeslots: any = [];

        value.map((value: any) => {
          const timeslot_object = {} as TimeSlotDetails | any;
          timeslot_object.timeSlot = value.timeSlot;
          timeslot_object.startTime = value.startTime;
          timeslot_object.endTime = value.endTime;
          timeslot_object.status = value.status;
          const tot = isNaN(value.total) ? 0 : value.total;
          timeslot_object.total =
            Number.parseInt(timeslotresponse.data.maxNumberOfEvents) - tot;
          timeslot_object.id = irt?.next()?.value;
          timeslot_object.helpText = generateHelpText(value);
          //
          Timeslots.push(timeslot_object);
        });

        const TotalTimeSlots = {} as TimeSlotDetailsArray;
        TotalTimeSlots.Date = key;
        TotalTimeSlots.TimeSlots = Timeslots;
        TimeSlotsDetailsArrayValue.push(TotalTimeSlots);
      });

      // handleTimeSlot(TimeSlotsDetailsArrayValue, maxLimitDate, targetLimitTime)
      settimeSlotData(TimeSlotsDetailsArrayValue);
      timeslotresponse.data.maxNumberOfEvents &&
        setMaxNumofTimeSlots(timeslotresponse.data.maxNumberOfEvents);
      console.log(TimeSlotsDetailsArrayValue, "timeslot converted array");
    }

    console.log(timeslotresponse.data, "testingresponsetimeslot");
  };

  const getslotdetails = (
    avail: any,
    modifiedStarttime: any,
    modifiedEndtime: any,
    uniqueItem?: any
  ) => {
    setColor(`${classes.blue}`);
    SetContextStartDate(modifiedStarttime);
    SetContextEndDate(modifiedEndtime);
    setChoosenTime(avail.target.value);
    setTimeslotid(avail.target.id);
    setBindtimeslotId(avail.target.id);
    setCurrentBtnClass(uniqueItem);
    // BindtimeslotId = avail.target.id;
    setBindtimeslotDate(avail.target.name);
    setStartDate(moment(bindtimeslotDate).format("YYYY-MM-DD"));
    setTargetDate(moment(avail.target.name).format("YYYY-MM-DD"));
    buildTimeSlot();
  };

  const timeslotbind = (objdate: any) => {
    // var itr = 0;
    if (objdate.TimeSlots != undefined) {
      return objdate.TimeSlots.map((objtime: any) => {
        // itr += 1;
        const modifiedStarttime = moment(objtime.startTime, "HH:mm:ss").format(
          "hh:mm A"
        );
        const modifiedEndtime = moment(objtime.endTime, "HH:mm:ss").format(
          "hh:mm A"
        );
        const slicedTimeslot =
          modifiedStarttime.slice(0, 5) +
          modifiedStarttime.slice(8, modifiedStarttime.length);

        const Currently = new Date();
        const todayDate = String(Currently.getDate()).padStart(2, "0");
        const todayMonth = String(Currently.getMonth() + 1).padStart(2, "0"); //January is 0!
        const todayYear = Currently.getFullYear();

        const todaysDate = todayMonth + "/" + todayDate + "/" + todayYear;

        if (todaysDate == objdate.Date || todaysDate > objdate.Date) {
          const startTime: any = objtime.startTime;
          const hoursdisplayed = startTime.split(":")[0];
          const minutesdisplayed = startTime.split(":")[1];
          const displayedTime = hoursdisplayed + ":" + minutesdisplayed;
          console.log(displayedTime);

          const Currently = new Date();
          const TimeatPresent = new Date(Currently.getTime());
          const currentHours = TimeatPresent.getHours();
          console.log(currentHours);
          const currentMinutes = TimeatPresent.getMinutes();
          console.log(currentMinutes);
          const Currenttime = currentHours + ":" + currentMinutes;
          console.log(Currenttime);

          if (objtime.status !== "Available") {
            let slotColor = "";

            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotBusy;
            }
            return (
              //
              <button
                type="button"
                name={objdate.Date}
                value={slicedTimeslot + "-" + modifiedEndtime}
                id={objtime.timeSlot}
                className={`${slotColor} ${
                  objtime.id == currentBtnClass
                    ? classes.currentTimeSlotBooking
                    : classes.currentTimeSlotCanceling
                }`}
                onClick={(e) =>
                  getslotdetails(
                    e,
                    modifiedStarttime,
                    modifiedEndtime,
                    objtime.id
                  )
                }
                disabled={true}
              >
                {slicedTimeslot} - {modifiedEndtime}
              </button>
            );
          } else if (
            todaysDate > objdate.Date ||
            (todaysDate == objdate.Date && displayedTime <= Currenttime)
            // eslint-disable-next-line sonarjs/no-duplicated-branches
          ) {
            let slotColor = "";

            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotBusy;
            }
            return (
              //
              <button
                type="button"
                name={objdate.Date}
                value={slicedTimeslot + "-" + modifiedEndtime}
                id={objtime.timeSlot}
                className={`${slotColor} ${
                  objtime.id == currentBtnClass
                    ? classes.currentTimeSlotBooking
                    : classes.currentTimeSlotCanceling
                }`}
                onClick={(e) =>
                  getslotdetails(
                    e,
                    modifiedStarttime,
                    modifiedEndtime,
                    objtime.id
                  )
                }
                disabled={true}
              >
                {slicedTimeslot} - {modifiedEndtime}
              </button>
            );
          } else {
            let slotColor = "";

            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotAvailable;
            }
            return (
              //
              <button
                type="button"
                name={objdate.Date}
                value={slicedTimeslot + "-" + modifiedEndtime}
                id={objtime.timeSlot}
                className={`${slotColor} ${
                  objtime.id == currentBtnClass
                    ? classes.currentTimeSlotBooking
                    : classes.currentTimeSlotCanceling
                }`}
                onClick={(e) =>
                  getslotdetails(
                    e,
                    modifiedStarttime,
                    modifiedEndtime,
                    objtime.id
                  )
                }
              >
                {slicedTimeslot} - {modifiedEndtime}
              </button>
            );
          }
        } else if (FVSConfigurable) {
          if (objtime.status !== "Available" || bestFit == "Y") {
            return (
              <button
                type="button"
                name={objdate.Date}
                value={slicedTimeslot + "-" + modifiedEndtime}
                id={objtime.timeSlot}
                className={`${classes.slotBusy} ${
                  objtime.id == currentBtnClass
                    ? classes.currentTimeSlotBooking
                    : classes.currentTimeSlotCanceling
                }`}
                onClick={(e) =>
                  getslotdetails(
                    e,
                    modifiedStarttime,
                    modifiedEndtime,
                    objtime.id
                  )
                }
                disabled={true}
              >
                {slicedTimeslot} - {modifiedEndtime}
              </button>
            );
          } else {
            let slotColor = "";
            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotAvailable;
            }
            return (
              //
              <>
                {objtime.helpText ? (
                  <RACTooltip
                    PopperProps={
                      headerPresent
                        ? {
                            style: {
                              marginTop: -100,
                              paddingBottom: 75,
                              paddingLeft: 5,
                            },
                          }
                        : {}
                    }
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {objtime.helpText}
                      </span>
                    }
                  >
                    <button
                      type="button"
                      name={objdate.Date}
                      value={slicedTimeslot + "-" + modifiedEndtime}
                      id={objtime.timeSlot}
                      className={`${slotColor} ${
                        objtime.id == currentBtnClass
                          ? classes.floatcurrentTimeSlotBooking
                          : classes.floatcurrentTimeSlotCanceling
                      }`}
                      onClick={(e) =>
                        getslotdetails(
                          e,
                          modifiedStarttime,
                          modifiedEndtime,
                          objtime.id
                        )
                      }
                    >
                      {slicedTimeslot} - {modifiedEndtime}
                      {!isNaN(objtime.total) && (
                        <span
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            left: "4px",
                            background: "#ff4757",
                            color: "white",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            borderRadius: "6px",
                            pointerEvents: "none",
                          }}
                        >
                          {objtime.total}
                        </span>
                      )}
                    </button>
                  </RACTooltip>
                ) : (
                  <button
                    type="button"
                    name={objdate.Date}
                    value={slicedTimeslot + "-" + modifiedEndtime}
                    id={objtime.timeSlot}
                    className={`${slotColor} ${
                      objtime.id == currentBtnClass
                        ? classes.floatcurrentTimeSlotBooking
                        : classes.floatcurrentTimeSlotCanceling
                    }`}
                    onClick={(e) =>
                      getslotdetails(
                        e,
                        modifiedStarttime,
                        modifiedEndtime,
                        objtime.id
                      )
                    }
                  >
                    {slicedTimeslot} - {modifiedEndtime}
                    {!isNaN(objtime.total) && (
                      <span
                        style={{
                          position: "absolute",
                          bottom: "4px",
                          left: "4px",
                          background: "#ff4757",
                          color: "white",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          borderRadius: "6px",
                          pointerEvents: "none",
                        }}
                      >
                        {objtime.total}
                      </span>
                    )}
                  </button>
                )}
              </>
            );
          }
        } else if (!FVSConfigurable) {
          if (objtime.status !== "Available" || bestFit == "Y") {
            let slotColor = "";
            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotAvailable;
            }
            return (
              <button
                type="button"
                name={objdate.Date}
                value={slicedTimeslot + "-" + modifiedEndtime}
                id={objtime.timeSlot}
                className={`${classes.slotBusy} ${
                  objtime.id == currentBtnClass
                    ? classes.currentTimeSlotBooking
                    : classes.currentTimeSlotCanceling
                }`}
                onClick={(e) =>
                  getslotdetails(
                    e,
                    modifiedStarttime,
                    modifiedEndtime,
                    objtime.id
                  )
                }
                disabled={true}
              >
                {slicedTimeslot} - {modifiedEndtime}
              </button>
            );
          } else {
            let slotColor = "";
            if (
              bindtimeslotId !== "" &&
              bindtimeslotId == objtime.timeSlot &&
              bindtimeslotDate !== "" &&
              bindtimeslotDate == objdate.Date
            ) {
              slotColor = classes.slotBooked;
            } else {
              slotColor = classes.slotAvailable;
            }
            return (
              //
              <>
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${
                    objtime.id == currentBtnClass
                      ? classes.currentTimeSlotBooking
                      : classes.currentTimeSlotCanceling
                  }`}
                  onClick={(e) =>
                    getslotdetails(
                      e,
                      modifiedStarttime,
                      modifiedEndtime,
                      objtime.id
                    )
                  }
                >
                  {slicedTimeslot} - {modifiedEndtime}
                </button>
              </>
            );
          }
        }
      });
    }
  };

  // const formatDate = (dates: any) => {
  //   //
  //   // const dateFormat = new Date(dates);
  //   // return (
  //   //     dateFormat.toString().slice(0, 3) +
  //   //     ', ' +
  //   //     dateFormat.toString().slice(4, 10)
  //   // );
  //   const dateFormat = moment(dates);
  //   return dateFormat.format('ddd, MMM DD');
  // };

  const formatDate = (dates: any) => {
    const dateFormat = new Date(dates);

    const dayKey = dateFormat.toUTCString().slice(0, 3);
    const monthKey = dateFormat.toUTCString().slice(8, 11);
    const date = dateFormat.toUTCString().slice(5, 7);

    // Translate day and month using t function or mapping dictionary
    const translatedDay = t(`${dayKey}`);
    const translatedMonth = t(`${monthKey}`);

    return `${translatedDay}, ${translatedMonth} ${date}`;
  };

  const handleCancel = async () => {
    setloader(true);
    if (multiMode && FVSdata.length > 1) {
      // if in multimode we must check to see if there is more to process
      // if more then stay on the screen and move to the next entry
      const items = shiftEntry();
      await processFVSCustomer(items);
    } else {
      if (paramValue) {
        history.push(`/storemgmt/dap`);
      } else {
        if (source?.current == "customer") {
          history.push({ pathname: `/am/customer/${data.customerId}` });
        } else if (source?.current == "priorityvisit") {
          history.push({ pathname: `/am/priorityvisit` });
        } else if (source?.current == "agreement") {
          history.goBack();
        } else {
          history.push({ pathname: `/am/past-due-list` });
        }
      }
    }
    setloader(false);
  };

  const handleRemoveAndCreateDelivery = async () => {
    try {
      setloader(true);

      let eventResponse: any = {};
     
      let payload = buildAppointmentActionPayload(
        EventStatusActionType.Cancel
      );
      // update the action type
      
      eventResponse = await updateEventStatus(payload);
     
      
      if (eventResponse?.status == 200) {
         const response: any = await scheduleDelivery(historyData?.agreementDetails);

        if (response?.status === 200) {
          // both succeeded !!
          SetOpendeliveryOverridepopup(true);
          
        } else {
          // Field Visit succeeded but the delivery failed
          SetOpenDeliveryFailedPopup(true);
          
        }            
        
      } else {
        // message indicating field visit failed 
        // go back to agreement
        setApierror(true);
        setApierrorContent(
          "Field Visit Update Failed. Please schedule events individually"
        );
          

      }
    } catch (e: any) {
      setApierrorContent("Something went wrong");
      setloader(false);
      setApierror(true);
    }
  };

  const buildTimeSlot = () => {
    if (timeSlotData != undefined && timeSlotData.length > 0) {
      let slotNumbers = 0;
      return timeSlotData.map((objdate: any) => {
        if (
          objdate.TimeSlots != null &&
          objdate.TimeSlots != "" &&
          slotNumbers < 5 //limit to max 5
        ) {
          slotNumbers++;
          const formattedDate = formatDate(objdate.Date);
          return (
            // eslint-disable-next-line react/jsx-key
            <Grid item className={classes.agrTimeSlot}>
              <Typography
                className={`${classes.semiBold} ${classes.font14} ${classes.MarginDate}`}
              >
                {formattedDate}
              </Typography>
              <Grid className={classes.agrListGroup}>
                {timeslotbind(objdate)}
              </Grid>
            </Grid>
            // </div>
            // </div>
            // </div>
          );
        }
      });
    } else {
      return (
        <div className={classes.Norecords}>
          {tsloader ? <CircularProgress /> : t("No available timeslots")}
        </div>
      );
    }
  };

  return (
    <>
      <div>
        <Modal
          isOpen={loader}
          className={classes.loaderStyle}
          id="openpopup"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          aria-hidden="true"
        >
          <Grid>
            <Grid>
              <Grid className={classes.RACLoaderPage}>
                <CircularProgress />
              </Grid>
            </Grid>
          </Grid>
        </Modal>
        <Grid>
          <List className={`${classes.breadcrumb}`}>
            <ListItem
              className={`${classes.breadcrumbItemActive}`}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                history.push({
                  pathname: `/dashboard`,
                });
              }}
            >
              {t("Dashboard")}
            </ListItem>
            <ListItem
              className={`${classes.breadcrumbItem} ${classes.breadcrumbArrow} ${classes.breadcrumbItemActive} `}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                handleCancel();
              }}
            >
              {paramValue ? t("DAP Events") : t("Account Management")}
            </ListItem>
            <ListItem
              className={`${classes.breadcrumbItem} ${classes.breadcrumbArrow} ${classes.racpadLinkCustomer}  `}
              style={{ cursor: "pointer" }}
            >
              {paramValue || isFVOverride ? t("Edit") : t("Create")} {t("Field Visit Event")}
            </ListItem>
          </List>
        </Grid>
        <Grid>
          <Typography
            variant="h4"
            style={{ marginTop: "1%", marginLeft: "1%" }}
          >
            {paramValue || isFVOverride ? t("Edit") : t("Create")} {t("Field Visit Event")}
          </Typography>
        </Grid>
        <Grid xs={12} style={{ marginBottom: "100px" }}>
          <Card className={classes.cardidle} style={{ marginTop: "0%" }}>
            <CardContent>
              <Grid
                container
                style={{ marginLeft: "20px", marginBottom: "20px" }}
              >
                <Grid item spacing={4}>
                  <Grid container>
                    <Grid item style={{ width: "100%" }}>
                      <Typography variant="h5" className={classes.subTitle2}>
                        {t("Customer List")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>{data.completeProcessingName}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent>
              <Grid
                container
                style={{ marginLeft: "20px", marginBottom: "40px" }}
              >
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={3}>
                      <Typography variant="h5" className={classes.subTitle2}>
                        {t("Customer Name")}
                      </Typography>{" "}
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="h5" className={classes.subTitle2}>
                        {t("Customer Address")}
                      </Typography>{" "}
                    </Grid>
                    <Grid item style={{ width: "100%" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={3}>
                          <Typography>
                            {data.firstName} {data.lastName}
                          </Typography>{" "}
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{t("Address Line")} 1</Typography>{" "}
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{t("Address Line")} 2</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{t("Zip")}</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{t("City")}</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{t("State")}</Typography>{" "}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={2}>
                          <Typography>{data.address1}</Typography>{" "}
                        </Grid>
                        <Grid item xs={2}>
                          <Typography>{data.address2}</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{data.postalCode}</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{data.city}</Typography>{" "}
                        </Grid>
                        <Grid item xs={1}>
                          <Typography>{data.state}</Typography>{" "}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container style={{ marginLeft: "20px" }}>
                <Grid item xs={3}>
                  <Typography variant="h5" className={classes.subTitle2}>
                    {t("Field Visit Details")}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      {
                        dateTimeLocalization == 1 ?
                          <RACMUIDatePicker
                            label={t("Date")}
                            required={true}
                            // className={classes.margintextsize}
                            // style={{ paddingLeft: '40%' }}
                            // classes={classes.margintextsize}
                            value={bindtimeslotDate}
                            // value={startDate}
                            onChange={(e: any) => chooseDates(e)}
                            inputProps={{
                              min: moment().format("YYYY-MM-DD"),
                              max: maxDate,
                            }}
                          /> :
                          <RACDatePicker
                            label={t("Date")}
                            required={true}
                            // className={classes.margintextsize}
                            // style={{ paddingLeft: '40%' }}
                            // classes={classes.margintextsize}
                            value={bindtimeslotDate}
                            // value={startDate}
                            onChange={(e: any) => chooseDates(e)}
                            inputProps={{
                              min: moment().format("YYYY-MM-DD"),
                              max: maxDate,
                            }}
                          />
                      }

                    </Grid>

                    <Grid item xs={8}>
                      <Typography variant="h6" className={classes.subTitle2}>
                        {t("CAR Instructions")}
                      </Typography>
                      <TextField
                        multiline
                        autoFocus
                        variant="outlined"
                        name="Description"
                        maxRows={3}
                        minRows={3}
                        fullWidth
                        value={data?.Description}
                        onChange={(e) => {
                          if (
                            data?.Description?.length >=
                            FIELD_VISIT_NOTES_MAX_LENGTH
                          ) {
                            const trimmedNote = e.target.value?.substring(
                              0,
                              FIELD_VISIT_NOTES_MAX_LENGTH
                            );
                            setData({ ...data, Description: trimmedNote });
                          } else {
                            setData({ ...data, Description: e.target.value });
                          }
                        }}
                      />
                      <span style={{ marginTop: "5px" }}>
                        ({FIELD_VISIT_NOTES_MAX_LENGTH}/
                        {data?.Description?.length})
                      </span>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={2} style={{ marginTop: "-75px" }}>
                      <RACTextbox
                        inputlabel={t("Time")}
                        name="Time"
                        // className={classes.margintextsize}
                        value={bestFit == "Y" ? "" : choosenTime}
                        disabled={true}
                        OnChange={Timebind}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <RACSelect
                        inputLabel={t("# Co-workers Required")}
                        loading={conditionLoader}
                        required={true}
                        options={coWorkerRequiredArray}
                        defaultValue={coworkers !== "" ? coworkers : "SELECT"}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                          setCoworkers(e.target.value);
                        }}
                        {...(coWorkerRequiredArray?.length == 1 &&
                          !conditionLoader && {
                            errorMessage: t("Unable to fetch Data"),
                          })}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container style={{ marginLeft: "20px" }}>
                <Grid item md={8} className={classes.spacerMT8}>
                  <Grid className={classes.floatLeft}>
                    <RACRadio
                      value={"N"}
                      checked={bestFit == "N"}
                      label={t("Selected time slot")}
                      onChange={(e: any) => handleSelectBestFitChange(e)}
                      name="bestfit"
                    />
                    <RACRadio
                      value={"Y"}
                      checked={bestFit == "Y"}
                      onChange={(e: any) => handleSelectBestFitChange(e)}
                      label={t("Best fit for the day")}
                      name="bestfit"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid container style={{ marginLeft: "20px" }}>
                <Grid item md={8} className={classes.spacerMT8}>
                  <Grid className={classes.floatLeft}>
                    <Typography variant="h5" className={classes.subTitle}>
                      {t("Select Available Timeslot")}
                    </Typography>
                    <Typography className={classes.deliveryEventDesc}>
                      {t("Only")} {maxNumofTimeSlots}{" "}
                      {t("events can be added in one time slot.")}
                    </Typography>
                  </Grid>
                  <Grid className={classes.floatRight}>
                    <Grid className={`${classes.floatLeft} ${classes.me48}`}>
                      <span className={classes.circleAvailable} />
                      <span>{t("Available")}</span>
                    </Grid>
                    <Grid
                      classes={{
                        root: clsx(classes.floatLeft, classes.spacerMR4),
                      }}
                    >
                      <span className={classes.circleBusy} />
                      <span>{t("Busy")}</span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  md={12}
                  className={classes.spacerMB5}
                  style={{ marginLeft: "1.5%" }}
                >
                  <Grid
                    style={{ width: "60%" }}
                    className={`${classes.mt2} ${classes.me2}`}
                  >
                    {buildTimeSlot()}
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Grid
            container
            classes={{
              root: clsx(classes.customerToolbar, classes.fixedBottom),
            }}
            style={{ zIndex: 0 }}
          >
            <Grid className={classes.footerFixed}>
              <Grid className={classes.floatLeft}>
                <RACButton
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancel}
                >
                  {t("Cancel")}
                </RACButton>
              </Grid>
              <Grid style={{ float: "right" }}>
                <RACButton
                  variant="contained"
                  color="primary"
                  style={{ float: "right" }}
                  disabled={
                    (choosenTime || bestFit == "Y") &&
                    coworkers &&
                    coworkers != "SELECT" &&
                    timeSlotData.length > 0
                      ? false
                      : true
                  }
                  onClick={(e) => {
                    handleSave();
                  }}
                >
                  {paramValue || isFVOverride ? t("Update") : t("Create")}
                </RACButton>
                { FVSConfigurable && isFVOverride ? (
                  <RACButton
                    variant="contained"
                    color="primary"
                    style={{ float: "right", marginRight: "20px" }}
                    disabled={
                      (choosenTime || bestFit == "Y") &&
                      coworkers &&
                      coworkers != "SELECT" &&
                      timeSlotData.length > 0
                        ? false
                        : true
                    }
                    onClick={(e) => {
                      handleRemoveAndCreateDelivery();
                    }}
                  >
                    {t("Remove")}
                  </RACButton>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid>
          {masterLoader ? (
            <Grid
              style={{
                position: "fixed",
                background: "#f7f5f5",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                opacity: 0.6,
                zIndex: 1050,
                textAlign: "center",
                margin: "0px 0px",
              }}
            >
              <Grid
                style={{
                  display: "block",
                  position: "fixed",
                  zIndex: 9999999,
                  top: "40%",
                  right: "50%",
                }}
              >
                <CircularProgress />
              </Grid>
            </Grid>
          ) : null}

          <RACModalCard
            isOpen={apierror}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={"9px !important"}
          >
            {apiErrorPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={errorMsg}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={"9px !important"}
          >
            {noRecordPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={OpendeliveryOverridepopup}
            borderRadius="15px"
            maxWidth="xs"
          >
            {DeliveryOverrideSuccessPopup()}
          </RACModalCard>
          <RACModalCard
            isOpen={OpenDeliveryFailedPopup}
            closeIcon={false}
            maxWidth="xs"
            borderRadius={"9px !important"}
          >
            {DeliveryOverrideFailurePopup()}
          </RACModalCard>
        </Grid>
      </div>
    </>
  );
}
